export const ROUTE_LICENSE_SCAN_UPLOAD = 'upload';
export const ROUTE_CYPRESS_LICENSE_SCAN = 'license-scan';
export const ROUTE_LICENSE_UPLOAD = 'upload-license';
